import {
  Box,
  Grid,
  GridItem,
  Heading,
  List,
  ListItem,
  OrderedList,
  UnorderedList,
} from "@chakra-ui/react";

import { ReactElement } from "react";
import { DEFAULT_BRAND_LOGO } from "../../constant/placeholders";
import Image from "../Image";
import Link from "../Link";

function Footer_1({
  logo,
  footerSections,
  listType = "unordered",
}: {
  logo?: string;
  footerSections?: {
    title: string;
    links?: {
      label: string;
      href: string;
    }[];
    contentHtml?: HTMLElement | ReactElement;
  }[];
  listType?: "ordered" | "unordered";
}) {
  const ListElement =
    listType === "ordered"
      ? OrderedList
      : listType === "unordered"
        ? UnorderedList
        : List;
  return (
    <Grid
      fontWeight="bold"
      templateColumns={`repeat(${footerSections ? footerSections.length + 1 : 5
        },1fr)`}
    >
      <GridItem>
        <Image
          maxW="full"
          id="brand_logo"
          className="navbar__brand__logo"
          src={logo}
          fallbackSrc={DEFAULT_BRAND_LOGO}
          alt="Logo"
        />
      </GridItem>
      {footerSections?.map((section, index) => (
        <GridItem key={`footer__section__${index}`}>
          <Box>
            <>
              <Heading
                as="h6"
                size="md"
                color="primary.500"
                textTransform="uppercase"
              >
                {section.title}
              </Heading>
              {section.contentHtml ? (
                section.contentHtml
              ) : (
                <ListElement mt="1rem" spacing={1}>
                  {section.links?.map((link, index1) => (
                    <ListItem key={`footer__section__link__${index1}`}>
                      <Link href={link.href}>{link.label}</Link>
                    </ListItem>
                  ))}
                </ListElement>
              )}
            </>
          </Box>
        </GridItem>
      ))}
    </Grid>
  );
}

export default Footer_1;
